module.exports = __webpack_public_path__ + "media/images/map/map4-2021a45b8022a569060ef35fa5d1013c.png";